export const colors = {
    primary: {
      blue: '#004A96',
      lightBlue: '#21A0D2'
    },
    gray: {
      50: '#F9FAFB',
      100: '#F3F4F6',
      700: '#374151',
      800: '#1F2937'
    }
  };
  